export const removeEmptyStrings = (payload: Record<string, any>) => {
    return Object.fromEntries(Object.entries(payload).map(([key, value]) => [key, value === '' ? null : value]))
}

export const trimStrings = (payload: Record<string, any>) => {
    return Object.fromEntries(
        Object.entries(payload).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]),
    )
}
